export const transportationTypesByKey = {
  truck: 'Truck',
  railcar: 'Railcar',
  barge: 'Barge',
  other: 'Other',
};

export const transportationTypes = Object.values(transportationTypesByKey);
